import { css } from "@emotion/react";
import { FONTS, fontSize } from "../../../../../../styles/fonts";

export const errorMessageStyles = [
  fontSize.x2,
  FONTS.SwarovskiFutura500,
  css`
    // pointer-events: none;
    z-index: 0;

    border-radius: 8px;

    display: flex;
    align-items: center;
    justify-content: flex-end;

    position: absolute;

    right: 12px;
    top: 0;
    height: calc(100% - 12px);

    transform: translate(0, -0.8em) scale(0.75);
    transform-origin: center right;
    transition: transform 0.2s ease-out;

    padding: 0 4px;

    background: var(--bg-error);
    color: var(--text-error);

    width: 80%;
    text-align: right;
    line-height: 1.05;
  `,
];
